import { render, staticRenderFns } from "./AddCompany.vue?vue&type=template&id=94986e22&scoped=true&"
import script from "./AddCompany.vue?vue&type=script&lang=js&"
export * from "./AddCompany.vue?vue&type=script&lang=js&"
import style0 from "./AddCompany.vue?vue&type=style&index=0&id=94986e22&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94986e22",
  null
  
)

export default component.exports